// Billing UI
import {
  money,
  locationsLabel
} from "../billing/shared";
import { I } from "../billing/icons";

const trialLabel = days =>
  days % 30 === 0 ? `${days / 30} months free` : `${days} days free`;

const FeatureRow = ({ label, included }) => (
  <div className={"pf-row" + (included ? "" : " off")}>
    <span className="pf-ico">
      {included ? <I.Check width="12" height="12" /> : <I.Dash />}
    </span>
    <span className="pf-label">{label}</span>
  </div>
);

const PlanCTA = ({
  plan,
  isSelected,
  activePlanExists,
  isCanceled,
  onChoose,
  onChangePlan,
  onCancel,
  onResume,
  onContact
}) => {
  if (plan.contactOnly) {
    return (
      <button className="btn btn-ghost btn-block" onClick={onContact}>
        Contact us
      </button>
    );
  }
  if (isSelected) {
    return (
      <div className="plan-cta-current">
        <div className="plan-current-tag">
          <I.Check width="13" height="13" /> Current plan
        </div>
        {isCanceled ? (
          <button className="link" onClick={onResume}>
            Resume subscription
          </button>
        ) : (
          <button className="link danger" onClick={onCancel}>
            Cancel subscription
          </button>
        )}
      </div>
    );
  }
  if (activePlanExists) {
    return (
      <button className="btn btn-ghost btn-block" onClick={onChangePlan}>
        Change plan
      </button>
    );
  }
  return (
    <button
      className={
        "btn btn-block " + (plan.recommended ? "btn-primary" : "btn-ghost")
      }
      onClick={onChoose}
    >
      Choose Plan
    </button>
  );
};

const PlanCard = ({ plan, isSelected, ...ctaProps }) => (
  <div
    className={
      "plan-card" +
      (plan.recommended ? " is-recommended" : "") +
      (isSelected ? " is-current" : "")
    }
  >
    {plan.recommended && (
      <div className="plan-ribbon">
        <I.Sparkle width="12" height="12" /> Recommended
      </div>
    )}
    <div className="plan-name-row">
      <div className="plan-name">{plan.name}</div>
      {isSelected && (
        <span className="badge badge-accent-solid">
          <I.Check width="11" height="11" /> Current
        </span>
      )}
    </div>

    <div className="plan-price">
      {plan.contactOnly || !plan.price ? (
        <span className="plan-price-custom">Custom pricing</span>
      ) : (
        <>
          <span className="plan-price-amt">{money(plan.price.unitAmount)}</span>
          <span className="plan-price-per">/mo</span>
        </>
      )}
    </div>
    <div className="plan-perbooking">
      {plan.perBookingFee
        ? `+ ${money(plan.perBookingFee)} per completed booking`
        : ""}
    </div>

    <div className="plan-promo">
      {plan.trialPeriodDays > 0 && (
        <>
          <span className="plan-trial-pill">
            <I.Gift width="12" height="12" /> {trialLabel(plan.trialPeriodDays)}
          </span>
          <div className="plan-trial-sub">
            Card required. Cancel anytime before the trial ends and you won't
            be charged.
          </div>
        </>
      )}
    </div>

    <div className="plan-desc">{plan.description}</div>

    <div className="plan-locations">
      <I.MapPin width="14" height="14" />{" "}
      {locationsLabel(plan.allowedNumberOfBranches)}
    </div>

    <div className="plan-features">
      {plan.subscriptionPlanFeatures.map(
        ({ subscriptionFeature, supported }, i) => (
          <FeatureRow
            key={i}
            label={subscriptionFeature.title}
            included={supported}
          />
        )
      )}
    </div>

    <div className="plan-cta">
      <PlanCTA plan={plan} isSelected={isSelected} {...ctaProps} />
    </div>
  </div>
);

export default PlanCard;
